// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyBJmvbZxrQyhdJDSmFYV73-DPNlgLBuXCU",
  authDomain: "happy-bubble-15dc8.firebaseapp.com",
  projectId: "happy-bubble-15dc8",
  storageBucket: "happy-bubble-15dc8.firebasestorage.app",
  messagingSenderId: "743087192332",
  appId: "1:743087192332:web:374db052b5f31a64c3b129",
  measurementId: "G-S0VY4XFMSD"
};


const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize analytics only in browser environment
let analytics = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.log('Analytics initialization skipped:', error.message);
  }
}
export { analytics };